import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Plus, Minus } from "lucide-react";

export function FAQ({ t }) {
  const [open, setOpen] = useState(0);
  const toggle = (i) => setOpen(open === i ? -1 : i);

  return (
    <section id="faq" className="relative section-pad border-t border-white/10">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-20">
          <div className="md:col-span-5">
            <div className="flex items-center gap-3 mb-6">
              <span className="inline-block w-8 h-px bg-[#00E5FF]" />
              <span className="eyebrow">{t.faq.eyebrow}</span>
            </div>
            <h2
              className="text-white font-semibold leading-[1.05] tracking-tight"
              style={{
                fontFamily: "'Outfit', sans-serif",
                fontSize: "clamp(30px, 4.5vw, 48px)",
              }}
            >
              {t.faq.heading}
            </h2>
            <p
              className="mt-6 text-[#9BA1A6] leading-relaxed max-w-md"
              style={{ fontFamily: "'Manrope', sans-serif", fontSize: "16px" }}
            >
              {t.faq.sub}
            </p>
          </div>

          <div className="md:col-span-7">
            <ul className="border-t border-white/10">
              {t.faq.items.map((item, i) => {
                const isOpen = open === i;
                return (
                  <li key={i} className="border-b border-white/10">
                    <button
                      type="button"
                      onClick={() => toggle(i)}
                      aria-expanded={isOpen}
                      data-testid={`faq-q-${i}`}
                      className="w-full flex items-center justify-between gap-6 text-left py-6 group"
                    >
                      <span
                        className={`text-base md:text-lg font-semibold transition-colors ${
                          isOpen ? "text-[#00E5FF]" : "text-white group-hover:text-[#00E5FF]"
                        }`}
                        style={{ fontFamily: "'Outfit', sans-serif" }}
                      >
                        {item.q}
                      </span>
                      <span
                        className={`shrink-0 w-9 h-9 rounded-full border flex items-center justify-center transition-colors ${
                          isOpen
                            ? "border-[#00E5FF] bg-[#00E5FF] text-[#0B132B]"
                            : "border-white/20 text-white group-hover:border-[#00E5FF] group-hover:text-[#00E5FF]"
                        }`}
                      >
                        {isOpen ? <Minus size={16} /> : <Plus size={16} />}
                      </span>
                    </button>
                    <AnimatePresence initial={false}>
                      {isOpen && (
                        <motion.div
                          key="content"
                          initial={{ height: 0, opacity: 0 }}
                          animate={{ height: "auto", opacity: 1 }}
                          exit={{ height: 0, opacity: 0 }}
                          transition={{ duration: 0.32, ease: "easeInOut" }}
                          className="overflow-hidden"
                          data-testid={`faq-a-${i}`}
                        >
                          <p
                            className="text-[#9BA1A6] leading-relaxed pb-6 pr-12 max-w-3xl"
                            style={{ fontFamily: "'Manrope', sans-serif", fontSize: "16px" }}
                          >
                            {item.a}
                          </p>
                        </motion.div>
                      )}
                    </AnimatePresence>
                  </li>
                );
              })}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}
